import React from 'react';
export const CHECKOUT_URL = 'https://chemistry-visual-mastersystem.impultienda.ar/checkout';
interface CTAButtonProps {
  label: string;
  href?: string;
  external?: boolean;
  className?: string;
}
export function CTAButton({
  label,
  href = '#get-access',
  external = false,
  className = ''
}: CTAButtonProps) {
  return <a href={href} {...external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} className={`cta-button flex min-h-[54px] w-full items-center justify-center rounded-[10px] bg-cta-green px-6 py-4 text-center text-base font-extrabold tracking-tight text-white shadow-lg shadow-cta-green/30 hover:bg-cta-green-deep focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cta-green sm:text-[17px] ${className}`} data-id="element-55" data-mp="2fy0fjo36mrzj">
      {label}
    </a>;
}